module.exports = __webpack_public_path__ + "images/102_4096.jpg";